// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"xr-z","breadcrumbForward":"yr-z","breadcrumbBack":"zr-z","selected":"Ar-z"};